export default {
  accepted_message: "진행 중 배팅이 접수되었습니다.",
  waiting_message: "대기중 베팅이 진행되는 중입니다.",
  login: "계속하려면 로그인하십시오...",
  password_rule: "* 암호는 대문자와 소문자를 구별하고 길이는 6자~10자여야 합니다.",
  nickname_rule: "* 로그인 및 화면에 표시할 닉네임을 설정하세요(6~15글자의 영숫자). 닉네임은 한 번만 설정할 수 있습니다. 한 번 설정하면 수정이나 취소가 불가능합니다.",
  change_password_succeed: "비밀번호 변경 성공.",
  add_secondary_succeed: "닉네임 설정 성공.",
  succeed: "작업을 성공적으로 완료했습니다!",
  failed: "작업을 완료하지 못했습니다!",
  no_information_available: "상세 정보를 볼 수없습니다.",
  select_display_language: "선호하는 기본 언어를 선택하십시오.",
  select_odds_type: "선호하는 기본 승산 유형 표시를 선택하십시오.",
  select_page_type: "오늘과 초기 시장 페이지 모두에 표시 할 기본 페이지 유형을 기본으로 선택하십시오.",
  select_show_score_map: "베팅을하는 동안 시스템이 맵 점수를 자동으로 표시하도록합니다.",
  select_default_event_sorting: "선호하는 기본 이벤트 정렬 표시를 선택하십시오.",
  select_market_type: "선호하는 시장을 선택하십시오.",
  select_page_size: "원하는 페이지 크기를 선택하십시오.",
  change_sports_menu_order: "스포츠 메뉴 오더의 순서를 변경하려면 해당 항목을 드래그하십시오.",
  view_outstanding_bets_in_bet_list: "미완료 베팅을 처리하려면 약간의 시간이 소요될 수 있습니다. 내 최신 미완료 베팅을 확인하시려면 베팅 목록으로 이동해 주십시오.",
  time_display_in_gmt_plus_8: "시간은GMT+8기준으로표시됩니다.",
  select_default_stake: "시스템이 맞춤형 스테이크 및 마지막 베팅 스테이크를 자동으로 입력 할 수 있도록합니다.",
  bet_empty: "베팅 슬립이 비어 있습니다.. 베팅을 선택하려면 테이블의 배당률을 클릭하십시오.",
  no_event: "현재 가능한 경기 또는 게임이 없습니다. 다른 스포츠 이벤트 또는 게임을 방문하시고 나중에 다시 접속해 주세요.",
  no_bets: "진행 중인 베팅 없음",
  no_waiting: "대기 베팅이 없습니다",
  no_void: "무효 베팅 없음",
  odds_changed: "승률이 변경되었습니다.",
  confirmation: "이 베팅을 하시겠습니까?",
  olderversion: "이전 버전이 감지되면 확인을 클릭하여 업데이트하거나 Ctrl-F5를 누르십시오.",
  gmt8: "시간은GMT+8기준으로표시됩니다.",
  no_betting_market: "베팅 마켓 없음",
  note_1: "미결제 베팅은 처리하는 데 시간이 걸릴 수 있습니다. 최신 베팅을 보려면 내 베팅으로 이동하십시오.",
  match_not_started: "경기가 시작되지 않았습니다",

  banner1a: "PICK A SPORT",
  banner1b: "GET IN THE GAME",
  banner1c:
    "With a comprehensive selection of over 90 sports and thousands of live matches to bet on, the adrenalin rush never ends. Don’t miss out on your chance to win with our offer of only the best odds and top sports picks on the market.",
  banner2a: "ROLL THE DICE",
  banner2b: "HIT THE JACKPOT",
  banner2c:
    "Rake in winnings, all while enjoying a rich and immersive casino gaming experience at any of our luxurious suites. Take a seat, play your favourite casino game, and be on the receiving end of quality interaction from live dealers, all from the comfort of wherever you are.",
  banner3a: "GAMING AT ITS FINEST",
  banner3b: "A REVOLUTIONARY EXPERIENCE",
  banner3c: "An extensive selection of games, as far as the eye can see. Get a firsthand taste of it now.",
  banner4a: "OLYMPIC GAMES",
  banner4b: "TOKYO 2020",
  banner4c: "The 2020 Summer Olympics, officially the Games of the XXXII Olympiad and also known as Tokyo 2020, is an upcoming international multi-sport event scheduled to be held from 23 July to 8 August 2021 in Tokyo",
  banner4d: "We Bringing Back The EURO CUP 2020 For You!",
  banner5a: "LIVE SPORTS & GAME HIGHLIGHTS",
  banner5aa: "REACH YOUR COMMUNITY IN REAL TIME",
  banner5b: "Watch the best free Live TV and Highlights on the web and mobile devices",
  banner5c: "Get the latest sports scores anytime, anywhere",

  banner6a: "E-Fighting",
  banner6b: "Play the best fighting games",
  banner6c: "Collect your favorite characters, throw down in competitive combat, enter the battlefield and feel the fight! The more you play, the more you win!",

  banner7a: "NEW ESPORTS INTERFACE",
  banner7b: "ALL NEW EXPERIENCE",
  banner7c: "Extensive Choices of Esports markets, Industry Leading Betting Experience.",
  banner7d: "Popular massive multiplayer, Unbeatable odds & speedy settlement.",
  
  banner8a: "V-GAMES",
  banner8b: "PLAY THE GAMES, AND EXPERIENCE A DIFFERENT KIND OF VICTORY.",
  banner8c: "Experience a whole new level of victory.",
  banner8d: "Immerse yourself in a variety of games, from competitive to fighting, and explore new genres that wil keep you engaged for hours.",

  bannersb:
    "Enjoy non-stop thrills and excitement with an endless variety of sporting competitions to wager on, both locally and from all across the world. With us, you’ll always have the best odds.",
  bannersl:
    "Take a break from reality, step right through, and experience for yourself the fantasies that have been brought to life in our vividly detailed virtual games. You’re sure to get addicted. ",
  bannerlc: "Step inside any of our exclusive casino suites, indulge in your classic casino favourites, and lose yourself in an interactive experience featuring gorgeous live dealers.",

  banner10a: "Wishing you a great fun time",
  banner10b: "While you row to the rhythm of roaring drums!",
  
  banner11a: "FIFA WORLD CUP QATAR 2022 WORLD'S BIGGEST NATIONAL TEAM TOURNAMENT",
  banner11b: "The World Cup 2022 will take place in Qatar from 20 November to 18 December 2022",
  banner11c: "A total of 32 teams, including hosts Qatar, have qualified for the tournament, which will be the first time football’s biggest event takes place in the Middle East.",
  
  join_us1: "MAKE THIS YOUR WORLD",
  join_us2:
    "With 24/7 action and a spectacular array of products to wager on, we cater to pretty much any and all types of preferences. Plus, we’ve got cool bonuses, ongoing promotions, and efficient payouts to ensure you enjoy the best gaming experience. Take the first step and sign up with us now. It’s quick, easy, and free.",
  join_us3: "JOIN US NOW",

  icon1a: "OPTIMIZED FOR MOBILE",
  icon1b: "Our games are accessible on popular mobile platforms, so you can game on the go on your favourite device",
  icon2a: "ADVANCED SECURITY & SUPPORT",
  icon2b: "Enjoy our games and transact with us with true peace of mind – our website is fully secure to safeguard your privacy and personal info",
  icon3a: "IMMERSIVE EXPERIENCE",
  icon3b: "Indulgent, intuitive, and interactive – we have curated and selectively chosen premium products that will deliver the excitement you seek",
  icon4a: "CUSTOMER SUPPORT",
  icon4b: "Your satisfaction is our priority. We would to hear from you should you have any feedback or queries that would help us serve you better",
  footer1a: "Underage Gambling",
  footer1b:
    "Gambling is illegal for kids under the age of 18. Every state prohibits gambling by minors.{fvalue} will carry out age verification randomly and winnings will be forfeited if the gambler is below 18 years old.© 2004-2019. {fvalue} is An Internationally Registered Trademark (Licensed Sports Bookmaker). All Rights Reserved.",

  contactus_title1: "Customer Service specialists are available to answer all your questions including payment concerns in English and Chinese language.",
  contactus_title2: "International call charges may apply to you. Phone calls to us may be recorded for customer protection, information verification, quality assurance purposes and regulatory compliance.",

  days: "일",
  hours: "시간",
  mins: "의사록",
  secs: "초",
  ldiff_changed: "Percent has changed",
  no_room: "사용 가능한 방이 없습니다. 다른 옵션을 선택하고 다시 검색하거나 나중에 다시 오십시오.",
  people_in_this_room: "이 방에 있는 사람들",
  room_full: "이 방은 꽉 찼습니다",
  room_joined: "이 방에 참여했습니다",
  my_room: "내 방",
  pin_code: "예: 123456",
  no_matches: "현재 가능한 경기나 게임이 없습니다.",
  are_you_sure: "이 작업을 진행하시겠습니까?",
  accept_terms: "체크 표시를 하면 위의 이용 약관을 읽고 이해했으며 동의했음을 확인하는 것입니다.",
  accept_required: "진행하기 전에 위의 이용약관을 읽고 이해하고<br />동의하세요.",
  must_accept_better_odds: "기본적으로 베팅은 더 나은 확률을 자동으로 수락합니다. 자세한 내용은 이용약관을 참조하십시오.",
  maintenance_notice: "현재 시스템 점검 중입니다. 나중에 다시 시도해 주세요.",
  not_winning_prize_in_this_tournament: "이 토너먼트에서 우승하지 못함",
  you_did_not_join_this_room: "당신은 이 방에 들어오지 않았습니다",
  deduct_confirm: "이 작업은 게임을 시작하고 여러분의 크레딧이 차감됩니다. <br /> 계속하시겠습니까?",
  over_max_match: "이 리그의 경기가 선택 가능한 최대 경기 수를 초과했습니다.<br />리그를 확장하고 원하는 경기를 선택하세요.",

  //tournament
  button_skip: "둘러보기 건너뛰기",
  button_previous: "이전",
  button_next: "다음",
  button_stop: "마침",
  button_continue: "계속",
  tour_content_1: "<h6>WBET 토너먼트에 오신 것을 환영합니다</h6><p>사이트 서포터만을 위한 흥미진진한 새 토너먼트를 발표하게 되어 기쁩니다.</p>",
  tour_content_2: "<h6>공개 방</h6><p>회원들은 일반적으로 입장료를 받고 서로 경쟁적인 게임 플레이에 참여합니다.</p>",
  tour_content_3: "<h6>비공개 방</h6><p>멤버는 입장을 위해 초대된 핀을 사용하여 친구들과 놀기 위해 방을 열 수 있습니다.</p>",
  tour_content_4: "<h6>공개 무료 방</h6><p>회원 전용 특별 이벤트 기간 동안 다양한 조직에서 조직하여 무료로 참여할 수 있습니다.</p>",
  tour_content_5: "<h6>총 플레이어가 참가 및 청구할 수 있습니다</h6><p>플레이어: 방의 수용 인원.</p><p>입장료: 방별 제안(계정 소유자의 통화).</ p>",
  tour_content_6: "<h6>방 세부 정보</h6><p>방 통계를 미리 보고 방에 참여하려면 여기를 클릭하세요.</p>",
  tour_content_7: "<h6>풀 세부 정보</h6><p>우승자의 총 풀 상금 및 검색할 고유 방 ID.</p>",
  tour_content_8: "<h6>방 시작 세부 정보</h6><p>방 상태 및 마지막 입장 시간 표시</p>",
  tour_content_9: "<h6>비공개 방 만들기</h6><p>비공개 방을 만들고 친구를 핀으로 초대하여 입장하세요.</p>",
  tour_content_10: "<h6>포인트 순위</h6><p>이 기능은 플레이어가 결과를 보고 추적할 수 있도록 포인트를 표시하는 것입니다.</p>",
};
